import { EReportControlId } from '~/presentation/reports/common/type';

export const isCampaignItemOperator = (id: string) => {
  return id === EReportControlId.CAMPAIGN_ITEM_OPERATOR;
};
